import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';

@Entity()
export class ScopedEntity extends MongoEntity {
  public static override _class = 'ScopedEntity';

  @Field(() => [String], {
    default: v => v ?? [GLOBAL_CONTEXT],
  })
  public scopes!: string[];
}
